import { FC, useState } from "react";
import { useFormik } from "formik";
import { Paper } from "@mantine/core";
import { UserRequestBodyType } from "constants/types/user";
import { createValidationSchema } from "./config";
import { FORM_IDS } from "pages/User/config";
import { userApi } from "apis";
import { useNotification } from "utils/hooks";
import { ErrorStatusType } from "constants/types/common";
import UserFormFields from "../UserFormFields/UserFormFields";
import { Loading } from "components";

type Props = {
  onClose?: () => void;
  mutate?: any;
};

const CreateForm: FC<Props> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formik = useFormik<UserRequestBodyType>({
    initialValues: {
      username: "",
      password: "",
      fullname: "",
      roles: [],
      phone: "",
      isActive: true,
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const _res = await userApi.createUser(values);
        if (_res.data.success) {
          notification.success({ title: "Tạo người dùng thành công" });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Tạo người dùng thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
          <UserFormFields
            formik={formik}
            isCreateMode={true}
            isPasswordReset={false}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default CreateForm;
